import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectGuideIsActive,
  selectGuideCurrentStep,
  selectGuideIsPopulating,
  selectGuidePopulationProgress,
  selectGuideState,
} from './courseGuideState';
import { useCourseGuideNavigation, useGuidePopulation } from './hooks';
import GuideOverlay from './components/GuideOverlay';
import StepNameAndCover from './components/steps/StepNameAndCover';
import StepTocBuilder from './components/steps/StepTocBuilder';
import StepModuleShowcase from './components/steps/StepModuleShowcase';
import StepSettings from './components/steps/StepSettings';

const STEP_COMPONENTS = [StepNameAndCover, StepTocBuilder, StepModuleShowcase, StepSettings];

const CourseGuide = ({ courseId }) => {
  const isActive = useSelector(selectGuideIsActive);
  const currentStep = useSelector(selectGuideCurrentStep);
  const isPopulating = useSelector(selectGuideIsPopulating);
  const populationProgress = useSelector(selectGuidePopulationProgress);
  const { startStep } = useSelector(selectGuideState);

  const { handleNext, handleBack, handleSkip, isNextDisabled } = useCourseGuideNavigation();
  const { populate } = useGuidePopulation(courseId);

  if (!isActive) return null;

  const StepComponent = STEP_COMPONENTS[currentStep];

  return (
    <GuideOverlay
      currentStep={currentStep}
      startStep={startStep}
      onNext={handleNext}
      onBack={handleBack}
      onSkip={handleSkip}
      onFinish={populate}
      isPopulating={isPopulating}
      populationProgress={populationProgress}
      isNextDisabled={isNextDisabled}
    >
      {StepComponent && <StepComponent />}
    </GuideOverlay>
  );
};

export default CourseGuide;
